export default {
  'footer.agreement': '法律协议',
  'footer.userAgreement': '用户服务协议',
  'footer.policy': '隐私政策',

  'footer.community': '社区',
  'footer.account': '官方账号',
};
